const recent = new Map<string, number>();
const TTL_MS = 12_000;

export function markOwnWrite(table: string, id: string | null | undefined): void {
  if (!id) return;
  recent.set(`${table}:${id}`, Date.now());
}

export function isOwnWrite(table: string, id: string | null | undefined): boolean {
  if (!id) return false;
  const key = `${table}:${id}`;
  const at = recent.get(key);
  if (!at) return false;
  if (Date.now() - at > TTL_MS) {
    recent.delete(key);
    return false;
  }
  return true;
}
